import { Button, JoonUIColor, Typography, UserRole } from "@joonapp/web-shared"
import { useTranslation } from "react-i18next"

import { useChildPasscodeModalStore } from "./useChildPasscodeModalStore"
import PasscodeInput from "../../../../components/passcodeInput/PasscodeInput"
import useMultiInputFocus from "../../../../hooks/useMultiInputFocus"
import { ChildPasscodeStep } from "../../../../types"
import useSelectedFamilyMember from "../../hooks/useSelectedFamilyMember"

const SetChildPasscode = () => {
  const { passcode, showError, setPasscode, setStep, setShowError } =
    useChildPasscodeModalStore()
  const { selectedProfile } = useSelectedFamilyMember()
  const { t } = useTranslation()
  const {
    ref: passcodeInputRef,
    focusFirstInput,
    clearInputs,
  } = useMultiInputFocus({ useEffectDelay: 200 })

  if (selectedProfile?.role !== UserRole.CHILD) return null

  const isChangingPasscode = selectedProfile?.user.account_passcode !== null

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    if (selectedProfile?.user.account_passcode === passcode) {
      setPasscode("")
      focusFirstInput()
      clearInputs()
      setShowError(true)
      return
    }
    setShowError(false)
    setStep(ChildPasscodeStep.CONFIRM_SET_PASSCODE)
  }

  return (
    <form onSubmit={handleSubmit}>
      <div className="flex flex-col gap-4">
        <div className="flex flex-col gap-2">
          <Typography variant="bodyBold">
            {isChangingPasscode
              ? t("CCP_SET_NEW_TITLE", { name: selectedProfile?.user.name })
              : t("CCP_SET_TITLE", { name: selectedProfile?.user.name })}
          </Typography>
          <Typography variant="bodySmall">
            {isChangingPasscode
              ? t("CCP_SET_DESC_REMINDER", { name: selectedProfile?.user.name })
              : t("CCP_SET_DESC", { name: selectedProfile?.user.name })}
          </Typography>
        </div>

        <PasscodeInput
          value={passcode}
          setValue={setPasscode}
          ref={passcodeInputRef}
        />

        <Button
          type="submit"
          text={t("PPC_NEXT")}
          fullWidth
          disabled={passcode.length !== 4}
        />
        {showError && isChangingPasscode && (
          <Typography variant="bodySmall" color={JoonUIColor.semantic.alert}>
            {t("PPC_ERR_DIFFERENT")}
          </Typography>
        )}
      </div>
    </form>
  )
}

export default SetChildPasscode
